/*
 *
 * TeamAnalysis actions
 *
 */

import {
  GET_DRILLDOWN_DIVISIONS_WATCHER,
  GET_DRILLDOWN_DIVISIONS_SUCCESS,
  GET_DRILLDOWN_DIVISIONS_FAILED,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GET_TEAMS_WATCHER,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAILED,
  GET_GRAPHIC_BAR_WATCHER,
  GET_GRAPHIC_BAR_SUCCESS,
  GET_GRAPHIC_BAR_FAILED,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_WATCHER,
} from "./constants"

export function getGraphicBarsWatcher(payload) {
  return {
    type: GET_GRAPHIC_BAR_WATCHER,
    payload,
  }
}

export function getGraphicBarsSuccess(payload) {
  return {
    type: GET_GRAPHIC_BAR_SUCCESS,
    payload,
  }
}

export function getGraphicBarsFailed() {
  return { type: GET_GRAPHIC_BAR_FAILED }
}

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DRILLDOWN_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DRILLDOWN_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DRILLDOWN_DIVISIONS_FAILED }
}

export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}

export function getTeamsWatcher(payload) {
  return {
    type: GET_TEAMS_WATCHER,
    payload,
  }
}

export function getTeamsSuccess(payload) {
  return {
    type: GET_TEAMS_SUCCESS,
    payload,
  }
}

export function getTeamsFailed() {
  return { type: GET_TEAMS_FAILED }
}

/* MEASURE RANGE COLOR */
export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}
